'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _antd = require('antd');

var _MessagesQueue = require('./MessagesQueue');

var _MessagesQueue2 = _interopRequireDefault(_MessagesQueue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var messagesQueue = new _MessagesQueue2.default();
var addMessagesQueue = {
  get: function get(target, propKey) {
    return function (_ref) {
      var id = _ref.id,
          onClose = _ref.onClose,
          props = _objectWithoutProperties(_ref, ['id', 'onClose']);

      props.onClose = function () {
        messagesQueue.delete(id);

        if (typeof onClose === 'function') {
          onClose();
        }
      };

      messagesQueue.add(id, function () {
        return target[propKey](props);
      });
    };
  }
};
var notification = new Proxy(_antd.notification, addMessagesQueue);
exports.default = notification;